import imageStreamUtil from './util'

export default {
  props: {
    imageStream: {
      type: Object
    },
    cssClass: {
      type: String,
      default: ''
    },
    rounded: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    alt: {
      type: String,
      default: ''
    }
  },
  computed: {
    enderecoImagem () {
      return imageStreamUtil.obterEnderecoImagem(this.imageStream)
    }
  }
}
